//@flow

import * as React from "react"
import SVGLoader from "../../UI/SVGLoader"
import iconMapMarker from "../Icons/iconMapMarker.svg"
import styled from "styled-components"

const Label = styled.h4`
  font-size: ${({ size }) => size || "30px"};
  font-family: "din-condensed";
  font-weight: 400;
  color: ${({ color }) => color || "#003659"};
  position: absolute;
  display: flex;
  align-items: center;
  top: -2px;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  text-align: center;
`

const LabelText = styled.span`
  display: block;
  margin: auto;
`

const Container = styled.div`
  height: ${({ height }) => height || 70}px;
  width: ${({ width }) => width || 51}px;
  position: relative;
  flex-shrink: 0;
  flex-basis: 51px;
`

const LocationMarker = ({
  labelText,
  labelSize,
  innerRef,
  height,
  width,
  fill,
  color
}: {
  labelText: string,
  labelSize?: string,
  innerRef?: (el: HTMLElement) => any,
  height?: number,
  width?: number,
  fill?: string,
  color?: string
}) => (
  <Container innerRef={innerRef} height={height} width={width}>
    <Label color={color} size={labelSize}>
      <LabelText>{labelText}</LabelText>
    </Label>
    <SVGLoader
      path={iconMapMarker}
      fill={fill || "#77c140"}
      height="100%"
      width="100%"
    />
  </Container>
)

export default LocationMarker



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/LocationMarker.js